<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :withEmplyFields="true"
                           :error="error"
                           :title="'editionFacture.problemOccurred'"
                           @close="error = $event"/>
      <div class="columns">
        <div class="column is-8">
          <div class="title is-5">
            <span>{{ $t('detail.commande.selectionEcheances.title') }} {{ codeCommande }}</span>
          </div>
        </div>
        <div class="column is-2">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('detail.commande.selectionEcheances.cancel')}}
          </button>
        </div>
        <div class="column is-2">
          <button class="button is-addOrEdit has-text-centered button-modal"
                  :class="{'disabled' : !anyEcheanceSelected()}"
                  @click="facturer">
            {{ $t('detail.commande.selectionEcheances.charge')}}
          </button>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('detail.commande.selectionEcheances.billDate')"
                   class="obligatoire">
            <b-datepicker show-week-number
                          v-model="dateFacture"
                          :editable="true"
                          nearby-selectable-month-days
                          icon="calendar-today"/>
          </b-field>
        </div>
        <div class="column is-3 is-offset-6">
          <b-field :label="$t('detail.commande.selectionEcheances.repartitionLibelle')">
            <b-select expanded v-model="calculeEnQuantite" :disabled="isDisabled">
              <option :value=true>
                {{ $t('detail.commande.selectionEcheances.repartitionItem.quantite') }}
              </option>
              <option :value=false>
                {{ $t('detail.commande.selectionEcheances.repartitionItem.prixUnitaire') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12">
          <b-checkbox v-model="genererFactureZero">
            <span class="has-text-weight-bold has-text-default">
              {{ $t('detailCommande.facturer.actions.genererFactureZero') }}
            </span>
          </b-checkbox>
        </div>
      </div>
      <div>
        <v-client-table class="hLimit"
                        :data="echeancePayeurs"
                        :columns="columns"
                        :options="options">
          <div slot="selected" slot-scope="props" class="has-text-centered">
            <b-checkbox v-model="props.row.selected"
                        :value="props.row"
                        @input="selectRow(props.row)"/>
          </div>
          <div slot="montant" slot-scope="props" class="has-text-right">
            {{props.row.montant | formatDevise}}
          </div>
          <div slot="libelle" slot-scope="props">
            <span v-html="props.row.libelle"></span>
          </div>
      <div slot-scope="props" slot="dateDebut">
        {{ props.row.dateDebut | formatDate }}
      </div>
      <div slot-scope="props" slot="dateFin">
        {{ props.row.dateFin | formatDate }}
      </div>
      <div slot-scope="props" slot="datePrevisionnelleFacturation">
        {{ props.row.datePrevisionnelleFacturation | formatDate }}
      </div>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, NO_PAGINATION, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';
import { factureGeneration } from '@/api/facture/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import libelleEcheance from '@/services/devisCommandes/libelleEcheance';
import echeanceFacturationPreselector from '@/services/devisCommandes/echeanceFacturationPreselector';
import validationCreationfacture from '@/services/devisCommandes/validation/validationCreationFacture';
import validationChampsObligatoireFacture from '@/services/devisCommandes/validation/validationChampsObligatoireFacture';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import autoriseEcheanceNegativeVente from '@/services/general/autoriseEcheanceNegativeVente';

export default {
  name: 'selection-echeances',
  props: {
    codeCommande: {
      type: String,
    },
    intervenants: {
      type: Array,
    },
    echeanciers: {
      type: Array,
    },
    ligneCommandes: {
      type: Array,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      echeancePayeurs: [],
      selectAllValue: false,
      calculeEnQuantite: true,
      dateFacture: new Date(),
      error: false,
      messages: [],
      genererFactureZero: false,
      messagesChampsVide: [],
      champsVide: [],
      echeanceNegativeVenteEstAutorise: false,
    };
  },
  computed: {
    columns() {
      const columns = ['selected', 'libelle', 'dateDebut', 'dateFin', 'montant', 'datePrevisionnelleFacturation'];
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$i18n.t('detail.commande.selectionEcheances.table.product'),
          dateDebut: this.$i18n.t('detail.commande.selectionEcheances.table.startDate'),
          dateFin: this.$i18n.t('detail.commande.selectionEcheances.table.endDate'),
          montant: this.$i18n.t('detail.commande.selectionEcheances.table.amount'),
          datePrevisionnelleFacturation: this.$i18n.t('detail.commande.selectionEcheances.table.billPrevDate'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortable: [],
        groupBy: 'payeurLibelle',
        sortingAlgorithm: this.sortSpe,
        columnsClasses: {
          selected: 'colonneSelected',
        },
      };
    },
    nbClientSelected() {
      if (this.echeancePayeurs === null) return 0;
      return this.echeancePayeurs.filter(echeance => echeance.selected).length;
    },
    iconSelectTotal() {
      if (this.selectAllValue) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    isDisabled() {
      const status = this.echeancePayeurs.filter((echeance) => {
        return echeance.selected && echeance.isTarifUnitaire;
      }).length > 0;
      if (status) this.setRepartition();
      return status;
    },
  },
  methods: {
    setRepartition() {
      this.calculeEnQuantite = false;
    },
    isTarifUnitaire(referenceEcheancier) {
      let hasTarifUnitaireRegroupement = false;
      this.ligneCommandes.forEach((ligneRegrouepemnt) => {
        ligneRegrouepemnt.lignesCommande.forEach((ligneEnfant) => {
          if (ligneEnfant.referenceEcheancier === referenceEcheancier
            && ligneRegrouepemnt.tarifUnitaire) hasTarifUnitaireRegroupement = true;
        });
      });
      return hasTarifUnitaireRegroupement;
    },
    anyEcheanceSelected() {
      if (this.echeancePayeurs === null) return false;
      return this.echeancePayeurs.filter(e => e.selected).length > 0;
    },
    initialiseListeEcheancePayeurs(payeurs, echeanciers, lignesCommandes) {
      const echeancePayeurLigne = [];
      if (!payeurs || payeurs.length === 0) return echeancePayeurLigne;
      echeanciers.forEach(echeancier => {
        let echeancierLignes = echeancier.echeancierLignes
          .filter(ligneEcheance => ligneEcheance.factureId === null
            && !ligneEcheance.facturationFaite);

        if (this.echeanceNegativeVenteEstAutorise) {
          echeancierLignes = echeancierLignes.filter(ligneEcheance => ligneEcheance.montant >= 0);
        }

        echeancierLignes.forEach(ligne => {
          const echeance = {
            payeurLibelle: payeurs.find(payeur => payeur.tiersId === ligne.tiersId).nomCommercial,
            libelle: '',
            dateDebut: moment(ligne.dateDebut),
            dateFin: moment(ligne.dateFin),
            montant: ligne.montant,
            datePrevisionnelleFacturation: moment(
              ligne.datePrevisionnelleFacturation,
            ),
            selected: false,
            isTarifUnitaire: this.isTarifUnitaire(echeancier.referenceEcheancier),
            referenceEcheancier: echeancier.referenceEcheancier,
            id: ligne.id,
          };
          echeance.libelle = libelleEcheance(lignesCommandes, echeancier.referenceEcheancier);

          echeancePayeurLigne.push(echeance);
        });
      });

      return echeancePayeurLigne.sort(this.compareEcheance);
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.echeancePayeurs.forEach(echeance => {
        echeance.selected = this.selectAllValue;
      });
    },
    selectRow(row) {
      const echeanceSelected = this.echeancePayeurs.find(echeance => echeance.id === row.id);
      echeanceSelected.selected = !echeanceSelected.selected;
    },
    compareEcheance(a, b) {
      let retour = a.payeurLibelle.localeCompare(b.payeurLibelle);
      if (retour === 0) { retour = (a.dateDebut - b.dateDebut); }
      if (retour === 0) { retour = a.libelle.localeCompare(b.libelle); }
      return retour;
    },
    sortSpe(data) {
      // Comme les colonnes ne sont pas triables je ne m'occupe pas de la colonne
      if (data) {
        data.sort(this.compareEcheance);
      }
      return data;
    },
    async facturer() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.error = false;
      try {
        const ids = [];
        this.echeancePayeurs.filter(echeance => echeance.selected).forEach((ech) => {
          ids.push(ech.id);
        });
        const dateFactureIso = formatIsoDate(this.dateFacture);
        const factures = (
          await factureGeneration({
            listeEcheancierLigneId: ids,
            dateFacturation: dateFactureIso,
            calculeEnQuantite: this.calculeEnQuantite,
            genererFactureZero: this.genererFactureZero,
          })
        ).data.result;
        if (factures && factures.length > 0) {
          if (factures.length === 1) {
            this.$router.push({ name: 'm.bodac.factures-edition', params: { id: factures[0].id } });
          } else {
            this.$router.push({ name: 'l.bodac.factures' });
          }
        } else {
          this.$emit('closeWithReload');
        }

        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          validationCreationfacture(e.response, this.messages);
          validationChampsObligatoireFacture(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },

  async mounted() {
    this.echeanceNegativeVenteEstAutorise = await autoriseEcheanceNegativeVente();
    this.echeancePayeurs = this.initialiseListeEcheancePayeurs(
      this.intervenants.filter(intervenant => intervenant.payeur),
      this.echeanciers,
      this.ligneCommandes,
    );
    echeanceFacturationPreselector(this.echeancePayeurs);
  },
};
</script>

<style scoped>
.button-modal {
  width: 100%;
  margin: 0px;
}

.hLimit{
  height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>
